<nav class="navbar">
  <a class="navbar__logo" routerLink="/">
    <img src="/assets/images/julio_graffin_logo.svg" alt="Julio Graffin Logo" />
  </a>

  <button class="flex lg:hidden ml-auto" type="button" (click)="toggleMenu()">
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <polyline
        id="globalnav-menutrigger-bread-bottom"
        fill="none"
        stroke="var(--color-accent)"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        points="2 12, 16 12"
        class="globalnav-menutrigger-bread"
      >
        <animate
          #animBottomOpen
          id="globalnav-anim-menutrigger-bread-bottom-open"
          attributeName="points"
          values="2 12, 16 12; 2 9, 16 9; 3.5 14.5, 14.5 3.5"
          dur="0.24s"
          begin="indefinite"
          fill="freeze"
          calcMode="spline"
          keySplines="0.42, 0, 1, 1; 0, 0, 0.58, 1"
        />
        <animate
          #animBottomClose
          id="globalnav-anim-menutrigger-bread-bottom-close"
          attributeName="points"
          values="3.5 14.5, 14.5 3.5; 2 9, 16 9; 2 12, 16 12"
          dur="0.24s"
          begin="indefinite"
          fill="freeze"
          calcMode="spline"
          keySplines="0.42, 0, 1, 1; 0, 0, 0.58, 1"
        />
      </polyline>
      <polyline
        id="globalnav-menutrigger-bread-top"
        fill="none"
        stroke="var(--color-accent)"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        points="2 5, 16 5"
        class="globalnav-menutrigger-bread"
      >
        <animate
          #animTopOpen
          id="globalnav-anim-menutrigger-bread-top-open"
          attributeName="points"
          values="2 5, 16 5; 2 9, 16 9; 3.5 3.5, 14.5 14.5"
          dur="0.24s"
          begin="indefinite"
          fill="freeze"
          calcMode="spline"
          keySplines="0.42, 0, 1, 1; 0, 0, 0.58, 1"
        />
        <animate
          #animTopClose
          id="globalnav-anim-menutrigger-bread-top-close"
          attributeName="points"
          values="3.5 3.5, 14.5 14.5; 2 9, 16 9; 2 5, 16 5"
          dur="0.24s"
          begin="indefinite"
          fill="freeze"
          calcMode="spline"
          keySplines="0.42, 0, 1, 1; 0, 0, 0.58, 1"
        />
      </polyline>
    </svg>
  </button>

  <ul class="navbar__menu">
    <li>
      <a href="javascript:void(0)" (click)="scrollToSection('projects')">
        {{ translate.translations().nav.work }}
      </a>
    </li>
    <li>
      <a
        routerLink="/quem-sou"
        routerLinkActive="text-(--color-accent) font-bold"
      >
        {{ translate.translations().nav.about }}
      </a>
    </li>
    <li>
      <a href="javascript:void(0)" (click)="scrollToSection('contact')">
        {{ translate.translations().nav.contact }}
      </a>
    </li>
  </ul>

  <div class="navbar__actions">
    <div class="navbar-select">
      <button
        type="button"
        class="select-trigger"
        aria-haspopup="listbox"
        aria-expanded="false"
      >
        <strong>{{ translate.currentLang() | uppercase }}</strong>
        <span></span>
      </button>

      <ul class="select-options" role="listbox">
        @for (lang of ["pt-br", "en-us", "es-es"]; track lang) {
          @if (lang !== translate.currentLang()) {
            <li role="option">
              <button type="button" (click)="translate.setLanguage(lang)">
                {{ lang }}
              </button>
            </li>
          }
        }
      </ul>
    </div>

    <a
      href="https://linkedin.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Acessar meu LinkedIn"
      class="hover:opacity-75 hidden lg:flex"
    >
      <span aria-hidden="true">
        <img src="../../../assets/images/linkedin_icon.svg" alt="LinkedIn" />
      </span>
    </a>
    <a
      href="https://github.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Acessar meu GitHub"
      class="hover:opacity-75 hidden lg:flex"
    >
      <span aria-hidden="true">
        <img src="../../../assets/images/github_icon.svg" alt="Github" />
      </span>
    </a>
  </div>
</nav>

@if (isOpen()) {
  <nav class="navbar-mobile" [class.is-open]="isOpen()">
    <ul class="navbar-mobile__menu">
      <li>
        <a href="javascript:void(0)" (click)="scrollToSection('projects')">
          {{ translate.translations().nav.work }}
        </a>
      </li>
      <li>
        <a
          routerLink="/quem-sou"
          routerLinkActive="font-bold"
          (click)="closeMenu()"
        >
          {{ translate.translations().nav.about }}
        </a>
      </li>
      <li>
        <a href="javascript:void(0)" (click)="scrollToSection('contact')">
          {{ translate.translations().nav.contact }}
        </a>
      </li>
    </ul>
  </nav>
}
